<script>
  import ResourceList from "../../components/ResourceList.svelte";
  import {
    apiCall,
    apiUpdate,
    apiCreate,
    apiDelete,
    notify
  } from "../../httpCommon";
  import { Head, Body, Row, Cell } from "@smui/data-table";
  import { navigate } from "svelte-routing";
  import { Textfield, Textshow, RichEdit } from "../../components";
  import Button, { Label, Icon } from "@smui/button";
  import { exclude } from "@smui/common/exclude.js";
  import MenuItemDialog from "./MenuItemDialog.svelte";

  export let vendorId;
  export let groupOptions;
  export let flagOptions;

  let records;
  let filter = { vendor_id: vendorId };
  let edited = [];
  let errors = {};
  let dialog;
  let list;

  $: props = exclude($$props, ["vendorId"]);

  function edit(row) {
    const actions = ["cancel", "save"];

    if (row.can_delete) {
      actions.unshift("delete")
    }
    dialog.open({ actions, data: row});
  }

  function create() {
    dialog.open();
  }

  async function close(e) {
    if (e.detail) {
      console.log("detail: ", e.detail);
      const { action, data } = e.detail;
      if (action === "delete") {
        del(data);
      } else if (action !== "cancel") {
        save(data);
      }
    }
  }

  async function del(data) {
    try {
      await apiDelete(`/menu-items`, data.id);
      list.refresh();
    } catch (error) {
      if (error.errors) {
        errors = error.errors;
      }
      notify(error);
    }
  }

  async function save(row) {
    console.log("saving ", row);
    errors = {};
    try {
      if (row.id) {
        row = await apiUpdate(`/menu-items`, row.id, row);
      } else {
        row = await apiCreate(`/menu-items`, row);
      }
      list.refresh();
    } catch (error) {
      console.log("Got errors", error.errors);
      if (error.errors) {
        errors = error.errors;
        dialog.open({actions: ["cancel", "save"], data: row, errors} );
      }
      notify(error);
    }
  }
</script>

{(console.log("MenuItems props now: ", props), "")}

<style>

.menu-items :global(tr.suspended, tr.deleted) {
  font-style: italic;
}

</style>

<div class="menu-items">
<ResourceList
  bind:this={list}
  resource="menu-items"
  {filter}
  bind:records
  {create}
  {...props} >
  <Head>
    <Row>
      <Cell>Name</Cell>
      <Cell>Group</Cell>
      <Cell>Amount</Cell>
      <Cell>Active</Cell>
    </Row>
  </Head>
  <Body>
    {#if records}
      {#each records as row}
        <Row on:click={() => edit(row)} class="pointer mdc-data-table__row {row.status}">
          <Cell>{row.name}</Cell>
          <Cell>{row.item_group}</Cell>
          <Cell>{row.amount}</Cell>
          <Cell>
            {#if row.status == 'active'}
              <i class="material-icons">check</i>
            {:else}
              <i class="material-icons">clear</i>
            {/if}
          </Cell>
        </Row>
      {/each}
    {/if}
  </Body>
</ResourceList>
</div>

<MenuItemDialog bind:this={dialog} on:close={close} {vendorId} {groupOptions} {flagOptions}/>
